/* @flow */

import { type NETGEM_API_PARENTAL_CONTROL } from '../../libs/netgemLibrary/v8/types/ParentalControl';

export const MAX_PROFILE_COUNT = 5;

export type Profile = {
  avatarId: string | null,
  gameProfileId: string | null,
  id: string, // UUID
  isDefault: boolean,
  isKid?: boolean,
  name: string,
  ntvBucketId: string | null, // Vodafone only
  pinCode?: string,
  restrictions?: NETGEM_API_PARENTAL_CONTROL,
};

export type ProfileList = Array<Profile>;

export type Profiles = { list: ProfileList, lockUserProfilesManagement?: boolean };

// Reconcile function should return null if no change is needed
export type Reconcilier = (profiles: Profiles) => Profiles | null;

export const DEFAULT_AVATAR_IDS: Array<string> = [
  'profile://netgem/generic/profile_01',
  'profile://netgem/generic/profile_02',
  'profile://netgem/generic/profile_03',
  'profile://netgem/generic/profile_04',
  'profile://netgem/generic/profile_05',
  'profile://netgem/generic/profile_06',
  'profile://netgem/generic/profile_07',
  'profile://netgem/generic/profile_08',
  'profile://netgem/generic/profile_09',
  'profile://netgem/generic/profile_10',
];
